import { render, staticRenderFns } from "./videofusionSystem.vue?vue&type=template&id=200023e9&scoped=true"
import script from "./videofusionSystem.vue?vue&type=script&lang=js"
export * from "./videofusionSystem.vue?vue&type=script&lang=js"
import style0 from "./videofusionSystem.vue?vue&type=style&index=0&id=200023e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200023e9",
  null
  
)

export default component.exports